import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import "primereact/resources/primereact.css";
import "primereact/resources/themes/saga-blue/theme.css";
import { classNames } from "primereact/utils";
import { useEffect, useState, useRef } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import {
  addBankDetails,
  removeBankDetails,
  setBank,
  setBankAccountNumber,
  setBankDesc,
  setPrimaryAccountNo,
  setTypesOfBankAccount,
  setTypesOfBankAccountDesc,
  setBankBranch,
  setBankBranchDesc,
  clearBankObj,
  setBankAccountNumberError,
} from "../../redux/bankSlice";
import Input from "../input/Input";
import ApiService from "../service/apiService";
import { SaveButton } from "./declerationDetails";
import { NextButton, PrevButton } from "./kycSidebar";
import { DynamicFieldSection } from "./personalDetails";
import LookupService from "../service/lookupService";
import { useToast } from "../other/Toast";
import { getTValue } from "../other/label";
import { confirmDialog } from "primereact/confirmdialog";
import { bankAccountNoValidation } from "../../helper/validationHelper";

function BankDetails() {
  const history = useHistory();
  const { t, i18n } = useTranslation();
  const toast = useToast();
  const typesOfBankAccount = useSelector(
    (state) => state.bankDetails.typesOfBankAccount
  );
  const typesOfBankAccountDesc = useSelector(
    (state) => state.bankDetails.typesOfBankAccountDesc
  );
  const bank = useSelector((state) => state.bankDetails.bank);
  const bankBranch = useSelector((state) => state.bankDetails.bankBranch);
  const bankAccountNumber = useSelector(
    (state) => state.bankDetails.bankAccountNumber
  );
  const primaryAccountNo = useSelector(
    (state) => state.bankDetails.primaryAccountNo
  );
  const dispatch = useDispatch();

  const [bankList, setBankList] = useState([]);
  const [bankBranchList, setBankBranchList] = useState([]);
  const [bankAccountTypeList, setBankAccountTypeList] = useState([]);
  const bankDetailsList =
    useSelector((state) => state.bankDetails.bankDetailsList) || [];
  const [bankDesc, setBankDesc] = useState();
  const [bankBranchDesc, setBankBranchDesc] = useState();
  // const bankDetailsError = useSelector(
  //   (state) => state.bankDetails.bankDetailsError
  // );

  const [loadingat, setLoadingat] = useState(false);
  const [loadingb, setLoadingb] = useState(false);
  const [loadingbr, setLoadingbr] = useState(false);

  const errorObj = useSelector((state) => state.bankDetails.errors);
  let {
    typesOfBankAccountError,
    bankError,
    bankBranchError,
    bankAccountNumberError,
    bankDetailsError,
  } = {};
  if (errorObj && errorObj.typesOfBankAccountError) {
    typesOfBankAccountError = errorObj.typesOfBankAccountError.message;
  }
  if (errorObj && errorObj.bankError) {
    bankError = errorObj.bankError.message;
  }
  if (errorObj && errorObj.bankBranchError) {
    bankBranchError = errorObj.bankBranchError.message;
  }
  if (errorObj && errorObj.bankAccountNumberError) {
    bankAccountNumberError = errorObj.bankAccountNumberError.message;
  }
  if (errorObj && errorObj.bankDetailsError) {
    bankDetailsError = errorObj.bankDetailsError.message;
  }


  useEffect(() => {
    // if (!lbankList) {
    //   LookupService.getBankList(dispatch);
    // }
    // if (!lbankAccountTypeList) {
    //   LookupService.getBankAccountTypeList(dispatch);
    // }

    // if (!lbankBranchList) {
    //   LookupService.getBankBranch(dispatch);
    // }

    setLoadingb(true);
    setLoadingat(true);
    ApiService.getBankList().then((response) => {
      console.log(response.data);
      setBankList(response.data.data);
      console.log(bankList);
    }).finally(() => setLoadingb(false));

    ApiService.getBankAccountTypeList().then((response) => {
      console.log(response.data);
      setBankAccountTypeList(response.data.data);
      console.log(bankAccountTypeList);
    }).finally(() => setLoadingat(false));
  }, []);

  const getBankBranchList = (bankCode) => {
    ApiService.getBankBranchList(bankCode).then((response) => {
      setBankBranchList(response.data.data);
    }).finally(() => setLoadingbr(false));
  };

  const getDescription = (pList, param) => {
    return ((pList && pList.find((p) => p.code === param)) || {}).descEng;
  };

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm({});
  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  const footer = () => (
    <div class=" p-field p-col-12 p-md-12">
      <div className="p-grid" style={{ flex: 3, padding: "0 10px" }}>
        <div style={{ flex: 1 }}>
          <PrevButton />
        </div>
        <div style={{ flex: 1 }}>
          <center>
            <SaveButton style={{ flex: 1 }} />
          </center>
        </div>
        <div style={{ flex: 1 }}>
          <center>
            <NextButton />
          </center>
        </div>
      </div>
    </div>
    // <div className="p-grid">
    //   <div className="p-col-12 p-md-5">
    //     <PrevButton />
    //   </div>
    //   <div className="p-col-12 p-md-2">
    //     <SaveButton />
    //   </div>
    //   <div className="p-col-12 p-md-3"></div>
    //   <div className="p-col-12 p-md-2">
    //     <NextButton />
    //   </div>
    // </div>
  );

  const displayConfirmModal = (param) => {
    console.log(param);
    confirmDialog({
      message: "Are you sure you want to proceed?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => dispatch(removeBankDetails(param)),
    });
  };

  return (
    <Card
      className="p-col-12 p-md-12 main-card"
      header={
        <h3 className="p-col-12 p-md-12 text-center">
          <i className="pi pi-credit-card" /> {t("bankDetails")}
        </h3>
      }
      footer={footer}
    >

      <div className="p-grid p-fluid p-col-12 p-md-12" style={{ margin: 0 }}>
        <div className="p-field p-col-12 p-md-3 stick-right">
          <label className="p-col-12 p-md-12" htmlFor="typesOfBankAccount">
            {t("typesOfBankAccount")}*
          </label>
          <Controller
            name="typesOfBankAccount"
            control={control}
            rules={{ required: "Bank Account Type is required." }}
            render={({ field, fieldState }) => (
              <Dropdown
                id={field.id}
                value={typesOfBankAccount}
                filter showClear
                disabled={loadingat}
                dropdownIcon={loadingat ? 'pi pi-spinner pi-spin' : 'pi pi-chevron-down'}
                onChange={(e) => {
                  dispatch(setTypesOfBankAccount(e.value));
                  field.onChange(e.value);
                  dispatch(
                    setTypesOfBankAccountDesc(
                      e.originalEvent.nativeEvent.target.ariaLabel
                    )
                  );
                }}
                options={bankAccountTypeList}
                optionLabel={(data) =>
                  getTValue(i18n, data.descEng, data.descNep)
                }
                placeholder={t("selectBankType")}
                optionValue="code"
              />
            )}
          />
          <span style={{ color: "red" }}>{typesOfBankAccountError}</span>
          {getFormErrorMessage("typesOfBankAccount")}
        </div>
        <div className="p-field p-col-12 p-md-3 stick-left stick-right">
          <label className="p-col-12 p-md-12" htmlFor="bank">
            {t("bank")}*
          </label>
          <Controller
            name="bank"
            control={control}
            rules={{ required: "Bank is required." }}
            render={({ field, fieldState }) => (
              <Dropdown
                id={field.id}
                value={bank}
                filter showClear
                disabled={loadingb}
                dropdownIcon={loadingb ? 'pi pi-spinner pi-spin' : 'pi pi-chevron-down'}
                onChange={(e) => {
                  dispatch(setBank(e.value));
                  field.onChange(e.value);
                  setBankDesc(e.originalEvent.nativeEvent.target.ariaLabel);
                  getBankBranchList(e.value);
                  LookupService.getAllBankBranchList(e.value).then(
                    (response) => {
                      setBankBranchList(response.data.data);
                    }
                  );
                }}
                options={bankList}
                optionLabel={(data) =>
                  getTValue(i18n, data.descEng, data.descNep)
                }
                placeholder={t("selectBank")}
                optionValue="code"
              />
            )}
          />
          <span style={{ color: "red" }}>{bankError}</span>
          {getFormErrorMessage("bank")}
        </div>
        <div className="p-field p-col-12 p-md-3 stick-right stick-left">
          <label className="p-col-12 p-md-12" htmlFor="bankBranch">
            {t("bankBranch")}
          </label>
          <Controller
            name="bankBranch"
            control={control}
            //  rules={{ required: "Bank Branch is required." }}
            render={({ field, fieldState }) => (
              <Dropdown
                id={field.id}
                value={bankBranch}
                filter showClear
                disabled={loadingbr}
                dropdownIcon={loadingbr ? 'pi pi-spinner pi-spin' : 'pi pi-chevron-down'}
                onChange={(e) => {
                  dispatch(setBankBranch(e.value));
                  field.onChange(e.value);
                  setBankBranchDesc(
                    e.originalEvent.nativeEvent.target.ariaLabel
                  );
                }}
                options={bankBranchList}
                optionLabel={(data) =>
                  getTValue(i18n, data.descEng, data.descNep)
                }
                placeholder={t("selectBankBranch")}
                optionValue="code"
              />
            )}
          />
          <span style={{ color: "red" }}>{bankBranchError}</span>
          {getFormErrorMessage("bankBranch")}
        </div>
        <div className="p-field p-col-12 p-md-3 stick-left">
          <label className="p-col-12 p-md-12" htmlFor="bankAccountNumber">
            {t("bankAccountNumbers")}*
          </label>
          {/* <Controller
            name="bankAccountNumber"
            control={control}
            rules={{ required: "Bank Account Number is required." }}
            render={({ field, fieldState }) => (
              <Input
                id={field.name}
                {...field}
                keyfilter="alphanum"
                placeholder={t("bankAccountNumber")}
                onChange={(e) => {
                  dispatch(setBankAccountNumber(e.target.value));
                  field.onChange(e.target.value);
                }}
                value={bankAccountNumber}
                className={classNames({ "p-invalid": fieldState.invalid })}
              />
            )}
          />
          <span style={{ color: "red" }}>{bankAccountNumberError}</span>
          {getFormErrorMessage("bankAccountNumber")} */}
          <Controller
            name="bankAccountNumber"
            control={control}
            rules={{ required: "Bank Account Number is required." }}
            render={({ field, fieldState }) => (
              <Input
                id={field.name}
                {...field}
                keyfilter="alphanum"
                placeholder={t("bankAccountNumber")}
                onChange={(e) => {
                  dispatch(setBankAccountNumber(e.target.value));
                  field.onChange(e.target.value);
                }}
                onBlur={(e) => {
                  const value = e.target.value.trim();
                  if (!value) {
                    dispatch(setBankAccountNumberError({
                      message: "Bank Account No. can't be empty.",
                      section: "BKD",
                    }));
                  }
                  else if (!bankAccountNoValidation(value)) {
                    dispatch(setBankAccountNumberError({
                      message: "Bank Account No. should be in alpha-numerical characters only.",
                      section: "BKD",
                    }));
                  }
                  else {
                    dispatch(setBankAccountNumberError({
                      message: null,
                      section: "BKD",
                    }));
                  }
                }}
                value={bankAccountNumber}
                className={classNames({ "p-invalid": fieldState.invalid })}
              />
            )}
          />
          <span style={{ color: "red", fontSize: "12px" }}>{bankAccountNumberError}</span>
          {getFormErrorMessage("bankAccountNumber")}
        </div>
        <div className="p-col-12 p-md-12">
          <div className="p-grid">
            <div
              className="p-col-12 p-md-12"
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Button
                onClick={handleSubmit((e) => {
                  console.log(typesOfBankAccount, bank, bankAccountNumber);
                  let bankObj = {
                    typesOfBankAccount,
                    bank,
                    bankAccountNumber,
                    isPrimaryAccount: primaryAccountNo == bankAccountNumber,
                    bankDesc,
                    bankBranch,
                    bankBranchDesc,
                    typesOfBankAccountDesc,
                  };
                  const checkBankAccount = bankDetailsList.find(
                    (p) =>
                      p.bankAccountNumber == bankAccountNumber &&
                      p.bank == bank &&
                      p.bankBranch == bankBranch
                  );
                  // Validation for specific Bank Account Number:
                  if (!bankAccountNumber || !/^[a-zA-Z0-9]+$/.test(bankAccountNumber)) {
                    dispatch(setBankAccountNumberError({ message: "Bank Account No. should be in alpha-numerical characters only.", section: "BKD" }));
                    return;
                  }
                  else if (checkBankAccount) {
                    toast.warning("Message", "Bank and Account Number must be different");
                    return;
                  }
                  if (bankAccountNumber == null || bankAccountNumber == "") {
                    toast.warning("Message", "Bank Account Number is required");
                    return;
                  }
                  dispatch(addBankDetails(bankObj));
                  dispatch(clearBankObj());
                })}
                style={{ textAlign: "center" }}
                className="add-button"
              >
                <i className="pi pi-plus">Add</i>{" "}
              </Button>
            </div>
          </div>
          <span style={{ color: "red" }}>{bankDetailsError}</span>
          <DataTable value={bankDetailsList}
            style={{ minWidth: 600 }}
            dataKey="bank">
            <Column
              header={t("typesOfBankAccount")}
              body={(rowData) => {
                return (
                  rowData.typesOfBankAccountDesc || rowData.typesOfBankAccount
                );
              }}
            ></Column>
            <Column
              header={t("bank")}
              body={(rowData) => {
                return rowData.bankDesc || rowData.bank;
              }}
            ></Column>
            <Column
              header={t("bankBranch")}
              body={(rowData) => {
                return rowData.bankBranchDesc || rowData.bankBranch;
              }}
            ></Column>
            <Column
              field="bankAccountNumber"
              header={t("bankAccountNumbers")}
            ></Column>
            <Column
              header={t("primary")}
              body={(rowData) => (
                <Checkbox
                  inputId={"primaryAccount" + rowData.bankAccountNumber + "_" + rowData.bank + "_" + (rowData.bankBranch || '')}
                  name="primaryAccount"
                  checked={rowData.isPrimaryAccount}
                  onChange={(e) => {
                    console.log("row", rowData);
                    dispatch(setPrimaryAccountNo({
                      bankAccountNumber: rowData.bankAccountNumber,
                      bank: rowData.bank,
                      bankBranch: rowData.bankBranch
                    }));
                  }}
                />
              )}
            ></Column>
            <Column
              header={t("action")}
              body={(rowData) => (
                <i
                  className="pi pi-trash"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    displayConfirmModal({
                      bankAccountNumber: rowData.bankAccountNumber,
                      bank: rowData.bank,
                      bankBranch: rowData.bankBranch
                    })
                    // dispatch(removeBankDetails(rowData.bankAccountNumber))
                  }
                />
              )}
            ></Column>
          </DataTable>
        </div>
      </div>
      <DynamicFieldSection />
    </Card>
  );
}

export default BankDetails;
